import React, { useState, useEffect } from 'react';
import styles from './Usage.module.scss';
import Wrapper from '../wrapper/Wrapper';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';
import Loader from 'component/atom/loader/Loader';
import FilterDropdown from 'component/Custom/FilterDropdown/FilterDropdown';
import moment from 'moment';

const Usage = ({ userId }) => {
  const [showDateModal, setShowDateModal] = useState(false);
  const [days, setDays] = useState('7 days');
  const [startDate, setStartDate] = useState(
    moment().subtract(7, 'days').format('YYYY-MM-DD')
  );
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));

  const { data, refetch, isFetching } = useFetch(
    ['user-usage', userId, startDate, endDate],
    userEndpoints.getUsageById(userId, startDate, endDate),
    { enabled: !!userId }
  );

  useEffect(() => {
    if (userId && startDate && endDate) {
      refetch();
    }
  }, [startDate, endDate, userId]);

  const fields = [
    { label: 'Number of questions', value: data?.data?.questionsCount },
    { label: 'Session Duration', value: data?.data?.sessionDuration || '-' },
    {
      label: 'Number of prompt per session',
      value: data?.data?.promptsPerSession || '-',
    },
  ];

  return (
    <Wrapper grid>
      {isFetching ? (
        <div className={styles.loader}>
          <Loader isComponent />
        </div>
      ) : (
        <>
          <div className={styles.filter}>
            <FilterDropdown
              days={days}
              handleSetDays={setDays}
              handleOpenCustomDates={() => setShowDateModal(true)}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              variant="secondary"
            />
          </div>

          <div className={styles.cont}>
            {fields.map((field, index) => (
              <div key={index} className={styles.details}>
                <h3>{field.label}</h3>
                <p>{field.value}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </Wrapper>
  );
};

export default Usage;
